import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import isUrlAbsolute from 'utils/isUrlAbsolute';

interface OwnProps extends React.HTMLAttributes<HTMLAnchorElement> {
  url: string;
}

const NavigationTag: FC<OwnProps> = ({ children, url, className }) => {
  if (isUrlAbsolute(url)) {
    return (
      <a className={className} href={url}>
        {children}
      </a>
    );
  }
  return (
    <Link to={url} className={className}>
      {children}
    </Link>
  );
};

export default NavigationTag;
